
    import { defineComponent } from 'vue';
    import { endpointIdComposition } from '../services';

	export default defineComponent({
        name: 'no-template-found',
        setup() {
            return { endpointIdComposition }
        }
	})
